module.exports = __webpack_public_path__ + "static/img/board.0b569826.svg";